import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import Navbars from './Assets/Components/Navbar/Navbars.jsx';
import Contact from './Assets/Components/Home/Contact.jsx'
import Home from './Assets/Components/Home/Home.jsx'
import Message_C from './Assets/Components/About/Message_C.jsx'
import Message_P from './Assets/Components/About/Message_P.jsx'
import Footer from './Assets/Components/Footer/Footer.jsx';
import Aim from './Assets/Components/About/Aim.jsx';
import Facilities from './Assets/Components/About/Facilities.jsx';
import About from './Assets/Components/About/About.jsx'
import Gallery from './Assets/Components/Gallery/Gallery.jsx';
import Videos from './Assets/Components/Gallery/Videos.jsx'
import Fees from './Assets/Components/Admission/Fees.jsx'
import Rules from './Assets/Components/Admission/Rules.jsx'
import TCverification  from './Assets/Components/TC/TCverification.jsx'
import Alumi from './Assets/Components/Alumi/Alumi.jsx';



function App() {
  return (
    <div className="App">
      <Navbars />
      <Routes>
        <Route path='/' Component={Home}></Route>
        <Route path='/Chairman_Message' Component={Message_C}></Route>
        <Route path='/Principal_Message' Component={Message_P}></Route>
        <Route path='/About' Component={About}></Route>
        <Route path='/Aim_&_Objectives' Component={Aim}></Route>
        <Route path='/Our_Facilities' Component={Facilities}></Route>
        <Route path='/Image_Gallery' Component={Gallery}></Route>
        <Route path='/Video_Gallery' Component={Videos}></Route>
        <Route path='/Rules_&_Regulations' Component={Rules}></Route>
        <Route path='/Fees_Structure' Component={Fees}></Route>
        <Route path='/TC_Verification' Component={TCverification}></Route>
        <Route path='/Alumi_s' Component={Alumi}></Route>
        <Route path='/Contact' Component={Contact}></Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
